module.exports = __webpack_public_path__ + "img/custom_bg2.2985a0d8.png";